var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.477 9.167-4.47-4.47 1.178-1.178L16.667 10l-6.482 6.482-1.178-1.178 4.47-4.47H3.334V9.167h10.143Z",
    fill: "#EDE7FD"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjQ3NjggOS4xNjY4OUw5LjAwNjgzIDQuNjk2ODlMMTAuMTg1MiAzLjUxODU1TDE2LjY2NjggMTAuMDAwMkwxMC4xODUyIDE2LjQ4MTlMOS4wMDY4MyAxNS4zMDM2TDEzLjQ3NjggMTAuODMzNkgzLjMzMzVWOS4xNjY4OUgxMy40NzY4WiIgZmlsbD0iI0VERTdGRCIvPgo8L3N2Zz4K";